import clsx from 'clsx';
import { useMemo } from 'react';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import { IEntityComponentProps } from '~interfaces/props';
import { CmsDownloads } from '~modules/downloads/CmsDownloads';
import { MamDownloads } from '~modules/downloads/MamDownloads';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';
import { splitToUniqueInt } from '~utils/split';
import styles from '~modules/downloads/Downloads.module.css';

export default function ModuleDownloads({ data, editing, className, onChange }: IEntityComponentProps) {
  const cmsAssetIds = getRelatedEntityIds(data, 'field_downloads');
  const mamAssetIdsRaw = data?.attributes?.field_mam_assets || '';
  const mamAssetIds = useMemo(() => splitToUniqueInt(mamAssetIdsRaw), [mamAssetIdsRaw]);

  if (!data) {
    return null;
  }

  const id = getModuleUrlIdFromData(data.id, data.type);

  const clsModule = clsx({ ...className?.module }, 'relative');
  const clsContainer = clsx('px-0 relative', { ...className?.container });
  const clsHeader = clsx('c-module__header row');
  const clsHeaderContent = 'col col-sm-12';
  const clsBody = clsx('c-module__content row d-flex flex-wrap');
  const clsBodyContent = clsx('u-margin-top-sm u-margin-bottom-lg o-field-text col col-sm-12');
  const clsList = clsx('u-margin-top-md col col-sm-12');

  return (
    <div className={clsModule} id={id}>
      <div className={clsContainer}>
        <div className={clsHeader}>
          <div className={clsHeaderContent}>
            <EditableField
              hide={data.attributes.field_hide_title}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={data.attributes.field_title.value}
              editing={editing}
              onChange={onChange}
            />
          </div>
        </div>
        <div className={clsBody}>
          {data.attributes.field_text && !data.attributes.field_hide_text ? (
            <div className={clsBodyContent}>
              <EditableField
                entityType={data.type}
                fieldName="attributes.field_text.value"
                data={data.attributes.field_text.value}
                editing={editing}
                onChange={onChange}
              />
            </div>
          ) : null}

          <div className={clsList}>
            <ul className={clsx(styles.list, 'downloads-list')}>
              <MamDownloads assetIds={mamAssetIds} />
              <CmsDownloads assetIds={cmsAssetIds} />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
